import { Navigate, useLocation } from "react-router-dom";
import { storageHelper } from '../../Helpers/storageHelper';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = storageHelper.getItem("token");
  const searchParams = new URLSearchParams(location.search);
  const queryToken = searchParams.get("Auth") || searchParams.get("token");

  return token || queryToken ? children : <Navigate to="/signin" replace />;
};

export default ProtectedRoute;
